module.exports = __webpack_public_path__ + "assets/superb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/superb.png
// module id = 1227
// module chunks = 7